import React from "react";
import { Phone, Mail, Clock, MapPin, Facebook, Instagram, Linkedin } from "lucide-react";
import { CONTACT } from "../data/site";
import { Reveal, SectionHeading } from "./Reveal";

export const Contact = () => (
  <section id="contact" className="mx-auto max-w-7xl px-5 md:px-8 py-24 md:py-32">
    <Reveal>
      <SectionHeading overline="Contact" title="Let's Get You Seen" />
    </Reveal>

    <div className="mt-12 grid lg:grid-cols-2 gap-8">
      <Reveal>
        <div className="space-y-px bg-line border border-line">
          <a href={`tel:${CONTACT.phoneRaw}`} data-testid="contact-phone" className="group flex items-center gap-4 bg-ink-900 hover:bg-ink-800 p-6 transition-colors">
            <span className="h-11 w-11 flex items-center justify-center border border-line text-orange"><Phone size={20} /></span>
            <div>
              <div className="text-white/40 text-xs uppercase tracking-wider">Phone</div>
              <div className="font-head font-bold text-lg">{CONTACT.phone}</div>
            </div>
          </a>
          <a href="#quote" onClick={(e) => { e.preventDefault(); document.getElementById("quote")?.scrollIntoView({ behavior: "smooth" }); }} data-testid="contact-quote" className="group flex items-center gap-4 bg-ink-900 hover:bg-ink-800 p-6 transition-colors">
            <span className="h-11 w-11 flex items-center justify-center border border-line text-orange"><Mail size={20} /></span>
            <div>
              <div className="text-white/40 text-xs uppercase tracking-wider">Enquiries</div>
              <div className="font-head font-bold text-lg">Send a Quote Request</div>
            </div>
          </a>
          <div className="flex items-start gap-4 bg-ink-900 p-6">
            <span className="h-11 w-11 flex items-center justify-center border border-line text-orange"><Clock size={20} /></span>
            <div>
              <div className="text-white/40 text-xs uppercase tracking-wider">Business Hours</div>
              {CONTACT.hours.map((h) => (
                <div key={h.day} className="font-body text-sm mt-1 flex gap-3">
                  <span className="text-white/60 w-20">{h.day}</span><span className="font-medium">{h.time}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="flex items-center gap-4 bg-ink-900 p-6">
            <span className="h-11 w-11 flex items-center justify-center border border-line text-orange"><MapPin size={20} /></span>
            <div>
              <div className="text-white/40 text-xs uppercase tracking-wider">Service Area</div>
              <div className="font-head font-bold text-lg">{CONTACT.area}</div>
            </div>
          </div>
          <div className="flex items-center gap-3 bg-ink-900 p-6">
            {[Facebook, Instagram, Linkedin].map((Icon, i) => (
              <a key={i} href="#" data-testid={`social-${i}`} className="h-11 w-11 flex items-center justify-center border border-line text-white/70 hover:text-white hover:bg-orange hover:border-orange transition-colors">
                <Icon size={18} />
              </a>
            ))}
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="h-full min-h-[420px] border border-line overflow-hidden">
          <iframe
            title="AUS/SIGNS location"
            data-testid="contact-map"
            src={`https://www.google.com/maps?q=${encodeURIComponent(CONTACT.mapQuery)}&output=embed`}
            className="w-full h-full grayscale contrast-125"
            style={{ border: 0, minHeight: 420 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </Reveal>
    </div>
  </section>
);
